/* eslint-disable no-unused-expressions */

export const handleFieldChange = ({ field, props }) => event => {
  field.onChange?.(event);
  props.onChange?.(event);
};

export const handleFieldBlur = ({ field, props }) => event => {
  field.onBlur?.(event);
  props.onBlur?.(event);
};

export const handleFieldFocus = ({ field, props }) => event => {
  field.onFocus?.(event);
  props.onFocus?.(event);
};

export const setChecked = ({ fieldValue, formValue, type }) => {
  let isChecked;

  switch (type) {
    case "checkbox":
      isChecked = formValue?.includes?.(fieldValue);
      break;
    case "switch":
      isChecked = fieldValue;
      break;
    case "radio":
      isChecked = String(formValue) === String(fieldValue);
      break;
    default:
      break;
  }

  return Boolean(isChecked);
};
